import { ENV } from "../utils/constants";
import api from "./api";

export const getGraphsSMS = async (): Promise<any[]> => {
  const params = {
    status_type: "SMS",
  };

  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/campaigns-status-by-semester`,
    { params }
  );

  // const email = await api.get(
  //   `/advertising-dashboard-${ENV}/metrics/count/campaigns-status-by-semester`,
  //   { params }
  // );

  return data?.content;
};
